import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=d2a38b70&scoped=true"
import script from "./MenuComponent.vue?vue&type=script&lang=js"
export * from "./MenuComponent.vue?vue&type=script&lang=js"
import style0 from "./MenuComponent.vue?vue&type=style&index=0&id=d2a38b70&prod&lang=scss&scoped=true"
import style1 from "./MenuComponent.vue?vue&type=style&index=1&id=d2a38b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a38b70",
  null
  
)

export default component.exports